<template>
  <div id="app" class="app-main">
    <v-header
      ref="header"
      :header-fixed="headerFixed"
      :isTran="isTran"
      :isMobile="isMobile"
      :tranNum="tranNum"
    ></v-header>
    <router-view class="main-content"/>
    <v-footer></v-footer>
  </div>
</template>

<script>
import header from "@/components/header/header_v2";
import footer from "@/components/footer/footer";
import {isMobileDevice} from "@/common/scripts/isMobile.js";

export default {
  name: "app",
  data() {
    return {
      headerFixed: false, // 固定导航(目前适用于移动端)
      isMobile: false,
      isTran: false,
      tranNum: 0, //透明度
    };
  },
  mounted() {
    this.resetRem();
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleResize);
    // 友盟统计
    const s = document.createElement("script");
    s.src = "https://s4.cnzz.com/z_stat.php?id=1279792272&web_id=1279792272";
    s.language = "JavaScript";
    document.body.appendChild(s);
    this.handleResize();
  },
  methods: {
    handleScroll(event) {
      let headerClientHeight = this.$refs.header.clientHeight;
      let scrollTop =
        event.target.scrollTop || document.documentElement.scrollTop;
      this.tranNum = scrollTop / 500;
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
      if (scrollTop >= headerClientHeight) {
        this.headerFixed = true;
      } else {
        this.headerFixed = false;
      }
    },
    handleResize() {
      let headerClientHeight = window.innerWidth;
      this.isMobile = isMobileDevice() || headerClientHeight < 768;
    },
    getTran(to) {
      this.isTran =
         to.path == "/hw16v" || to.path == "/hw60v" || to.path == "/hw120v" || to.path == "/hw150v" || to.path == "/about-us" || to.path == "/company";
    },
  },
  components: {
    "v-header": header,
    "v-footer": footer,
  },
  created() {
    if (localStorage.getItem("LANG")) {
      //中文
      if (localStorage.getItem("LANG") == "zh_CN") {
        this.$i18n.locale = "zh_CN";
      } else if (localStorage.getItem("LANG") == "en_US") {
        this.$i18n.locale = "en_US";
      }
    } else {
      localStorage.setItem("LANG", "zh_CN");
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
  },
  watch: {
    $route(to, from) {
      this.getTran(to);
      document.documentElement.scrollTop = document.body.scrollTop = 0;
      // 友盟统计
      if (window._czc) {
        let location = window.location;
        let contentUrl = location.pathname + location.hash;
        let refererUrl = "/";
        window._czc.push(["_trackPageview", contentUrl, refererUrl]);
      }
    },
  },
};
</script>

<style>
.app-main {
  height: 100%;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
}

.main-content {
  min-width: 1200px;
  margin: 0 auto;
}

@media all and (max-width: 768px) {
  .main-content {
    min-width: 100%;
  }
}

/* 滚动条的宽度(包括横向纵向) */
::-webkit-scrollbar {
  width: 4px;
  height: 8px;
}

/* 滚动条的滑块 */
::-webkit-scrollbar-thumb {
  background-color: #a1a3a9;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue